export default {
  login: "facebook",
  id: 69631,
  node_id: "MDEyOk9yZ2FuaXphdGlvbjY5NjMx",
  avatar_url: "https://avatars.githubusercontent.com/u/69631?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/facebook",
  html_url: "https://github.com/facebook",
  followers_url: "https://api.github.com/users/facebook/followers",
  following_url: "https://api.github.com/users/facebook/following{/other_user}",
  gists_url: "https://api.github.com/users/facebook/gists{/gist_id}",
  starred_url: "https://api.github.com/users/facebook/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/facebook/subscriptions",
  organizations_url: "https://api.github.com/users/facebook/orgs",
  repos_url: "https://api.github.com/users/facebook/repos",
  events_url: "https://api.github.com/users/facebook/events{/privacy}",
  received_events_url: "https://api.github.com/users/facebook/received_events",
  type: "Organization",
  site_admin: false,
  name: "Meta",
  company: null,
  blog: "https://opensource.fb.com",
  location: "Menlo Park, California",
  email: null,
  hireable: null,
  bio: "We are working to build community through open source technology. NB: members must have two-factor auth.",
  twitter_username: "MetaOpenSource",
  public_repos: 116,
  public_gists: 12,
  followers: 0,
  following: 0,
  created_at: "2009-04-02T03:35:22Z",
  updated_at: "2022-04-01T07:03:49Z",
};
